import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NetworkUserListControllerWithContext } from '../network-user-list/network-user-list.controller';
import { useNetworkContext } from '../network.context';
import { InformationTabLoadingComponent } from './tabs/information-tab/information-tab-loading.component';
import { InformationTabComponent } from './tabs/information-tab/information-tab.component';

enum TabsEnum {
  INFORMATION = 'information',
  USERS = 'users',
}

export const NetworkDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const network = useNetworkContext();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('delmonicos-shared-sdk.outputs-network.description'),
          key: TabsEnum.INFORMATION,
          icon: 'info-circle',
        },
        {
          title: t('$.user-list.title'),
          key: TabsEnum.USERS,
          icon: 'users-01',
        },
      ] as const,
    [t],
  );

  const { tab: currentTab, setTab: setCurrentTab } = useTabQuery(
    TabsEnum.INFORMATION,
    extractTabKeys(tabs),
  );

  const renderTab = () => {
    if (currentTab === TabsEnum.INFORMATION) {
      if (!network) {
        return <InformationTabLoadingComponent />;
      }
      return <InformationTabComponent />;
    }
    return <NetworkUserListControllerWithContext />;
  };

  // HANDLERS //////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.XL} direction="column" flex={1}>
      <Tabs
        currentTab={currentTab}
        onTabClick={setCurrentTab}
        elements={tabs}
      />
      {renderTab()}
    </Stack>
  );
};
